export const isExternalUrl = (url: string): boolean => {
  if (!url || url.startsWith('/') || url.startsWith('#')) {
    return false
  }
  try {
    const hostname = new URL(url).hostname
    return !hostname.includes('hearingtracker.com')
  } catch {
    return false
  }
}

export const domainOf = (url: string): string => {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return 'unknown'
  }
}
